// extracted by mini-css-extract-plugin
export var card = "_m9-5";
export var cardSelected = "_m9-4";
export var image = "_m9-3";
export var modal = "_m9-0";
export var modalContent = "_m9-1";
export var table = "_m9-2";